import _mergeJSXProps from '@vue/babel-helper-vue-jsx-merge-props'
import { createNamespace } from 'vant/lib/utils'
import { inherit } from 'vant/lib/utils/functional' // Types

var _createNamespace = createNamespace('sku-header-item')
var createComponent = _createNamespace[0]
var bem = _createNamespace[1]

function SkuHeader (h, props, slots, ctx) {
    return h('div', _mergeJSXProps([{
        'class': bem()
    }, inherit(ctx)]), [slots.default && slots.default()])
}

export default createComponent(SkuHeader)
